import { TranslateService } from '@ngx-translate/core';
import { DialogObject } from '../../../../components/dialog/dialog.types';
import { AddressRepository } from '../../../../store/address-state/address-state.repository';

interface getAddressDeleteObjectProps {
  t: TranslateService;
  store?: AddressRepository;
  representation?: string | number;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getAddressDeleteObject = ({ t, store, representation, action, toggleVisiblity }: getAddressDeleteObjectProps): DialogObject => {
  return {
    title: t.instant('settings.address.deleteAddress.title', { representation: representation }),
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'common.dialog.confirm',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'common.dialog.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
